import PropTypes from 'prop-types';
import { formShell } from '../styles/formShell';

const FormToggle = ({
    label,
    disabled = false,
    className = '',
    id,
    name,
    checked,
    onChange,
}) => {
    const rowClass = disabled ? formShell.toggleRowDisabled : formShell.toggleRow;

    return (
        <label
            htmlFor={id}
            className={[rowClass, className].filter(Boolean).join(' ')}
        >
            <span className={formShell.toggleSwitchWrap}>
                <input
                    id={id}
                    type="checkbox"
                    name={name}
                    checked={checked}
                    onChange={onChange}
                    disabled={disabled}
                    className={formShell.toggleInput}
                />
                <span className={formShell.toggleTrack} aria-hidden="true" />
                <span className={formShell.toggleThumb} aria-hidden="true" />
            </span>
            {label && (
                <span className={disabled ? formShell.toggleLabelDisabled : formShell.toggleLabel}>
                    {label}
                </span>
            )}
        </label>
    );
};

FormToggle.propTypes = {
    label: PropTypes.node,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    id: PropTypes.string,
    name: PropTypes.string,
    checked: PropTypes.bool,
    onChange: PropTypes.func,
};

export default FormToggle;
